module.exports = __webpack_public_path__ + "static/media/tip-jar.784a26ba.jpg";